import { render } from "./MetodoFrenkel.vue?vue&type=template&id=6c076a85&scoped=true"
import script from "./MetodoFrenkel.vue?vue&type=script&lang=js"
export * from "./MetodoFrenkel.vue?vue&type=script&lang=js"

import "./MetodoFrenkel.vue?vue&type=style&index=0&id=6c076a85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c076a85"]])

export default __exports__